/* TDS product page: size tiles with price + per-gram price + "Best value", and the price on the add-to-cart button.
   Only decorates the theme's own variant labels and button; variant switching and cart stay the theme's. */
(function () {
  var dataEl = document.getElementById('tds-pdp-variants');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var variants = data.variants || [];
  if (!variants.length) return;

  function money(cents) {
    var n = cents / 100;
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }
  function grams(s) {
    var m = String(s).match(/([\d.]+)\s*(g|gram|grams)\b/i);
    if (m) return parseFloat(m[1]);
    m = String(s).match(/([\d.]+)\s*oz\b/i);
    return m ? parseFloat(m[1]) * 28 : 0;
  }
  var single = variants.every(function (v) { return v.options.length === 1; });
  var byValue = {};
  variants.forEach(function (v) { byValue[v.options[0]] = v; });

  // best value: lowest price per gram among 3+ weighed sizes
  var weighed = single ? variants.filter(function (v) { return grams(v.options[0]) > 0; }) : [];
  var best = null, basePpg = 0;
  if (weighed.length >= 3) {
    weighed.forEach(function (v) {
      v.ppg = v.price / grams(v.options[0]);
      if (!best || v.ppg < best.ppg) best = v;
    });
    basePpg = weighed.reduce(function (a, v) { return Math.max(a, v.ppg); }, 0);
  }

  function decorate() {
    var root = document.querySelector('.product-detail__variant-picker');
    if (!root || !single) return;
    root.classList.add('tp-sizes');
    root.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var label = root.querySelector('label[for="' + input.id + '"]');
      var v = byValue[input.value];
      if (!label || !v || label.querySelector('.tp-size__price')) return;
      label.classList.add('tp-size');
      var price = document.createElement('span');
      price.className = 'tp-size__price';
      price.textContent = money(v.price);
      label.appendChild(price);
      var g = grams(v.options[0]);
      if (g && weighed.length >= 2) {
        var per = document.createElement('span');
        per.className = 'tp-size__per mono';
        per.textContent = money(Math.round(v.price / g)) + '/g';
        label.appendChild(per);
      }
      if (best && v.id === best.id && basePpg > best.ppg) {
        var save = Math.round((1 - best.ppg / basePpg) * 100);
        var badge = document.createElement('span');
        badge.className = 'tp-size__badge mono';
        badge.textContent = save >= 5 ? 'Best value · save ' + save + '%' : 'Best value';
        label.appendChild(badge);
      }
    });
  }

  function current() {
    var form = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var id = form ? parseInt(form.value, 10) : 0;
    var v = variants.filter(function (x) { return x.id === id; })[0];
    if (!v && single) {
      var checked = document.querySelector('.product-detail__variant-picker input[type="radio"]:checked');
      if (checked) v = byValue[checked.value];
    }
    return v || variants[0];
  }

  function label() {
    var btn = document.querySelector('.product-detail__buy-buttons .product-form__submit');
    if (!btn) return;
    var lab = btn.querySelector('.btn-label');
    if (!lab) return;
    var v = current();
    if (btn.disabled || !v.available) { lab.removeAttribute('data-tp'); return; }
    var text = 'Add to cart · ' + money(v.price);
    if (lab.getAttribute('data-tp') !== text || lab.textContent.trim() !== text) {
      lab.setAttribute('data-tp', text);
      lab.textContent = text;
    }
  }

  function run() { decorate(); label(); }
  run();
  var t;
  var info = document.querySelector('.product-detail__information') || document.body;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 60); })
    .observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'value'] });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.product-detail__variant-picker')) setTimeout(run, 30);
  });
})();

/* "Continue shopping" (phones) and the breadcrumb (desktop): point at the collection or search the shopper
   actually came from, keeping their filters; with no such referrer, the product's main category. */
(function () {
  var a = document.querySelector('[data-tp-back]');
  if (!a) return;
  var nameEl = a.querySelector('[data-tp-back-name]');
  var names = {};
  try { names = JSON.parse(a.getAttribute('data-names') || '{}'); } catch (e) {}
  var ref = null;
  try { if (document.referrer) ref = new URL(document.referrer); } catch (e) {}
  var fromSearch = false;
  if (ref && ref.host === location.host) {
    var m = ref.pathname.match(/^\/collections\/([^\/]+)\/?$/);
    if (m && names[decodeURIComponent(m[1])]) {
      a.href = ref.href; nameEl.textContent = names[decodeURIComponent(m[1])];
    } else if (ref.pathname === '/search') {
      a.href = ref.href; nameEl.textContent = '(search results)'; fromSearch = true;
    }
  }
  var label = fromSearch ? 'Search results' : nameEl.textContent.trim();
  if (!label) return;

  // theme breadcrumb: Home · <collection> · Product
  var list = document.querySelector('.breadcrumbs .breadcrumb-list');
  if (list && !list.querySelector('[data-tp-crumb]')) {
    var items = list.querySelectorAll('.breadcrumb-item');
    var last = items[items.length - 1];
    if (items.length === 2 && last) {
      var li = document.createElement('li');
      li.className = 'breadcrumb-item dot-between inline-flex align-center light-dark-grey';
      li.setAttribute('data-tp-crumb', '');
      var link = document.createElement('a');
      link.className = 'breadcrumb-link no-underline light-dark-grey';
      link.href = a.href; link.textContent = label;
      li.appendChild(link);
      list.insertBefore(li, last);
    }
  }
  // the theme's grid icon next to the breadcrumb ("back to collection") goes to the same place
  var grid = document.querySelector('.breadcrumbs .nav-back');
  if (grid) grid.href = a.href;
})();

/* In-store review flow: /pages/rate links here with ?rate=1. Open Judge.me's write-a-review form once its widget is ready,
   and show a pill back to the rate page so people can rate the next thing they bought. */
(function () {
  if (!/[?&]rate=1\b/.test(location.search)) return;
  var back = document.createElement('a');
  back.href = '/pages/rate';
  back.className = 'tp-rate-back';
  back.textContent = '← Rate something else';
  document.body.appendChild(back);
  var tries = 0;
  (function open() {
    var w = document.getElementById('judgeme_product_reviews');
    var btn = w && Array.prototype.find.call(w.querySelectorAll('button, a'), function (b) {
      return /write a review/i.test(b.textContent) && b.offsetParent;
    });
    var box = document.querySelector('.jdgm-write-review-modal__container');
    if (box && box.getBoundingClientRect().width > 0) return;          // form is open
    if (btn) { if (tries === 0 || !w.dataset.tpScrolled) { w.scrollIntoView({ block: 'start' }); w.dataset.tpScrolled = '1'; } btn.click(); }
    if (++tries < 40) setTimeout(open, btn ? 700 : 300);
  })();
})();
